export default "__VITE_ASSET__DYlV6O4k__"